import { GeckoNotificationProvider } from 'features/notifications'
import React from 'react'

import { ProcessFlowDiagramBuilderDataLayer } from './contexts/ProcessFlowDiagramBuilderContext'
import { ProcessFlowDiagramBuilder } from './ProcessFlowDiagramBuilder'
import { PfdNode } from './types'

interface ProcessFlowDiagramProps {
  siteID: string
  diagramID: string
  viewOnly?: boolean
  onNodeClick?: (node: PfdNode) => void
  renderNodePopup?: (node: PfdNode, onClose: () => void) => React.ReactNode
}

export const ProcessFlowDiagram: React.FC<ProcessFlowDiagramProps> = ({
  siteID,
  diagramID,
  viewOnly = false,
  onNodeClick,
  renderNodePopup,
}) => {
  return (
    <>
      <GeckoNotificationProvider>
        <ProcessFlowDiagramBuilderDataLayer
          siteID={siteID}
          diagramID={diagramID}
          viewOnly={viewOnly}
          onNodeClick={onNodeClick}
          renderNodePopup={renderNodePopup}>
          <ProcessFlowDiagramBuilder viewOnly={viewOnly} />
        </ProcessFlowDiagramBuilderDataLayer>
      </GeckoNotificationProvider>
    </>
  )
}
